import { entities } from "sbtech-sports-data-api-client";
import * as Models from "../../Models";
import { DeviceType } from "sb-resp-lib";

export function parseSelection(
    selection: entities.Selection,
    market: entities.Market,
    selectedOddsType: string,
    displayName: string
): Models.Selection {
    {
        return new Models.Selection(
            {
                marketId : market.id,
                id: selection.id,
                sbTechId: selection.metadata.idSBTech,
                outcomeType: selection.outcomeType ? selection.outcomeType.toString() : "",
                name: selection.name,
                displayName,
                type: market.marketType.id,
                displayOdds: selection.displayOdds,
                odds: selection.displayOdds[selectedOddsType],
                points: selection.points ? selection.points : 0,
                isDisabled: selection.isDisabled,
                lineGroupId: selection.group.toString()
            });
    }
}

export interface SelectionDisplayPhrases {
    Draw: string;
}

export function getSelectionDisplayName(
    selectionName: string,
    outcome: string,
    type: string,
    deviceType: DeviceType,
    phrases: SelectionDisplayPhrases
): string {
    {
        let newName : string = selectionName;
        if (deviceType !== DeviceType.desktop &&
            type === "1_0")
        {
            newName = getMLPhrase(outcome, newName, phrases);
        };

        return newName;
    }
}
function getMLPhrase(outcome: string, newName: string, phrases: SelectionDisplayPhrases) {
    switch (true) {
        case (outcome === entities.OutcomeType.Home.toString()):
            newName = "1";
            break;
        case (outcome === entities.OutcomeType.Draw.toString() || outcome === entities.OutcomeType.Tie.toString()):
            newName = phrases.Draw;
            break;
        case (outcome === entities.OutcomeType.Away.toString()):
            newName = "2";
            break;
    }
    return newName;
}
